export enum WebControllers {
    Answer = "Answer",
    Banner = "Banner",
    Favorite = "Favorite",
    Feedback = "Feedback",
    FeedbackType = "FeedbackType",
    QuestionManagement = "QuestionManagement",
    Search = "Search",
    Reporting = "Reporting"
}